import * as queries from '@queries/utils';

export const fetchContacts = () => queries.getQuery('/api/contacts');

export const createContacts = (contacts) => queries.postQuery('/api/contacts', contacts);

export const updateContacts = (contacts) => queries.putQuery(`/api/contacts`, contacts);

export const deleteContacts = (contactsToDelete) => queries.deleteQuery(`/api/contacts`, contactsToDelete);